import React, { FC } from "react";
import { twMerge } from "tailwind-merge";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  textClassName?: string;
}

const CustomRadio: FC<IProps> = ({ children, textClassName, ...props }) => {
  return (
    <>
      <div className="relative">
        <input type="radio" className="sr-only" {...props} />
        <div className="flex justify-center items-center w-5 h-5 box">
          {props.checked ? (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="#F1F4FF" stroke="#012169" />
              <circle cx="10" cy="10" r="5" fill="#012169" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#DFE4EA" />
            </svg>
          )}
        </div>
      </div>
      <p className={twMerge("font-medium text-black whitespace-nowrap", textClassName ?? "")}>{children}</p>
    </>
  );
};
export default CustomRadio;
